import { recordEventCustomOnly } from 'utilities/uTagging';

export const doTagNationalityOpen = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'dropdown',
        component: 'form',
        element: 'nationality',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'nationalityDropdown',
        eventLabel: 'open',
    });
};

export const doTagNationalityClose = () => {
    recordEventCustomOnly({
        action: 'close',
        format: 'dropdown',
        component: 'form',
        element: 'nationality',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'nationalityDropdown',
        eventLabel: 'close',
    });
};

export const doTagNationalityOnChange = () => {
    recordEventCustomOnly({
        action: 'select',
        format: 'dropdown',
        component: 'form',
        element: 'nationality',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'nationalityDropdown',
        eventLabel: 'select',
    });
};

export const doTagID = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'idDocument',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'idDocumentTextBox',
    });
};

export const doTagName = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'name',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'nameTextBox',
    });
};

export const doTagLastName = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'surname1',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'surname1TextBox',
    });
};

export const doTagSecondLastName = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'surname2',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'surname2TextBox',
    });
};

export const doTagBirthDay = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'dayBirthDate',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'dayBirthDateTextBox',
    });
};

export const doTagBirthMonth = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'monthBirthDate',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'monthBirthDateTextBox',
    });
};

export const doTagBirthYear = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'yearBirthDate',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'yearBirthDateTextBox',
    });
};

export const doTagIsResident = isResident => {
    recordEventCustomOnly({
        action: 'click',
        format: 'radioButton',
        component: 'form',
        element: 'fiscalResidence',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickRadioButton',
        eventLabel: isResident ? 'Yes' : 'No',
    });
};

export const doTagTin = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'tin',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'tinTextBox',
    });
};

export const doTagIsValidAndGoNext = () => {
    recordEventCustomOnly({
        event_name: 'event_success',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'success',
        eventLabel: 'backend',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'personalData',
    });
};
